import modemsFilterSlice from './modemFilters-slice';

export const { setModemsFilters, resetState, resetModemsFiltersState } = modemsFilterSlice.actions;

export default modemsFilterSlice;
